import React from "react";
import ReactPlayer from "react-player";
import Audio from "./Audio";
import "./nima.css";

function getGoogleDriveEmbedUrl(url) {
  const match = url && url.match(/drive\.google\.com\/file\/d\/([\w-]+)/);
  return match ? `https://drive.google.com/file/d/${match[1]}/preview` : null;
}

function Nima({ theme, current_content }) {

  switch (current_content) {
    case 1:
      return (
        <div>
          {theme.audio_content ? <Audio audio={theme.audio_content} /> : null}

          <div className="safetext" dangerouslySetInnerHTML={{ __html: theme.content }}></div>


        </div>
      );
    case 2: {
      const driveEmbedUrl = getGoogleDriveEmbedUrl(theme.media);

      return (
        <div>
          {driveEmbedUrl ? (
            <div className="video-embed-wrapper">
              <iframe
                src={driveEmbedUrl}
                allow="autoplay"
                allowFullScreen
                style={{ border: 0 }}
                title="video"
              />
            </div>
          ) : (
            <ReactPlayer controls={true} url={theme.media} />
          )}
        </div>
      );
    }
    case 3:
      return (
        <div>
          {
            theme.show_material.map((item) => {
              return (
                <div>
                  <div className="professiogramma-box_img">
                    <img src={item.content} alt="rasm" />
                  </div>
                </div>
              )
            })
          }
        </div>
      );
    case 4:
      return (
        <div>
          <div dangerouslySetInnerHTML={{ __html: theme.practical_assignment }}></div>

        </div>
      );

    default:
      break;
  }
}

export default Nima;
